import { render, staticRenderFns } from "./GItemSettingForm.vue?vue&type=template&id=4d401f9c&scoped=true&"
import script from "./GItemSettingForm.vue?vue&type=script&lang=ts&"
export * from "./GItemSettingForm.vue?vue&type=script&lang=ts&"
import style0 from "./GItemSettingForm.vue?vue&type=style&index=0&id=4d401f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d401f9c",
  null
  
)

export default component.exports